import React from 'react';
import './LandingPage.css';

const AdsCreator = () => {
  return (
      <div className="LandingPage divmain">
          <header>
              <div className="container">
                  <h1>CREA IL TUO SPOT E GUADAGNA CON PSICOPATICI ITALIA</h1>
                  <p className='mb-0'>Sei un giovane talento pronto a dominare il mondo della moda digitale?</p>
                  <p>Diventa parte del nostro programma esclusivo di partnership e crea i tuoi spot!</p>
              </div>
          </header>


          <section className="how-it-works">
              <div className="container">
                  <h2>Come iniziare a guadagnare come Partner Ads Creator?</h2>
                  <div className="cards-container">
                      {[
                          {
                              title: "Inizia a promuoverti",
                              desc: "Registrati, ricevi il tuo link/codice e inizia a pubblicare contenuti"
                          },
                          {
                              title: "Guadagna su ogni acquisto",
                              desc: "Fino al 24% di commissioni su ogni vendita"
                          },
                          {
                              title: "Ottieni bonus extra",
                              desc: "0,50 € per ogni registrazione cliente tramite il tuo link"
                          }
                      ].map((item, i) => (
                          <div key={i} className="card1" style={{display: "flex", flexDirection: "column"}}>
                              <p><strong>{item.title}</strong></p>
                              <p style={{color: "gray", fontSize: "12px"}}>{item.desc}</p>
                          </div>
                      ))}
                  </div>

                  <div className="mt-4">
                      <h5>💰 Dettaglio Commissioni:</h5>
                      <div className="cards-container">
                          {[
                              {range: "0–50 acquisti", value: "15%"},
                              {range: "51–300 acquisti", value: "18%"},
                              {range: "301–1000 acquisti", value: "21%"},
                              {range: "Oltre 1000 acquisti", value: "24%"}
                          ].map((item, i) => (
                              <div key={i} className="card1" style={{display: "flex", flexDirection: "column"}}>
                                  <p><strong>{item.range}</strong></p>
                                  <p style={{color: "gray", fontSize: "14px"}}>{item.value} di commissione</p>
                              </div>
                          ))}
                      </div>
                      <p className="mt-3" style={{fontSize: "14px"}}>
                          📌 Guadagni automatici per 12 mesi su ogni cliente acquisito, anche senza ulteriori clic.
                      </p>
                  </div>
              </div>
          </section>

          <section className="how-it-works">
              <div className="container">
                  <h2>Perché diventare Partner Ads Creator?</h2>
                  <div className="cards-container">
                      {[
                          "✅ Nessun costo iniziale\tIngresso gratuito nel programma\n",
                          "📹 Creatività libera\tTotale autonomia nello stile e nel tipo di contenuto: video, foto, reel, spot\n",
                          "🧠 Supporto creativo del brand\tAccesso a materiali ufficiali e linea guida creativa\n",
                          "📈 Provvigioni in crescita\tCommissioni che aumentano con i risultati\n",
                          "📦 Nuovi capi ogni settimana\tSezione “Just Arrived” sempre aggiornata per nuovi contenuti (coming soon)\n",
                          "📊 Tracciamento trasparente\tOgni acquisto o registrazione è monitorato tramite il tuo link personale\n"
                      ].map((text, i) => (
                          <div key={i} className="card1">
                              <p>{text}</p>
                          </div>
                      ))}
                  </div>
              </div>
          </section>


          <section className="how-it-works">
              <div className="container">
                  <h2>I benefici riservati ai nostri partner</h2>
                  <div className="cards-container">
                      {[
                          "🎥 Visibilità ufficiale: possibilità di essere ricondivisi sui canali del brand",
                          "🧰 Kit creativo fornito da Psicopatici Italia (brief, grafiche, musica, loghi)",
                          "📚 Accesso alla Libreria Virtuale del brand",
                          "📦 Accesso prioritario agli articoli in uscita",
                          "🎟️ Opportunità di partecipare a contest, eventi, selezioni pubblicitarie",
                          "🏆 Possibilità di evolvere nel ruolo di regista ufficiale per le campagne"
                      ].map((text, i) => (
                          <div key={i} className="card1">
                              <p>{text}</p>
                          </div>
                      ))}
                  </div>
              </div>
          </section>

          {/* REQUISITI */}
          <section className="how-it-works">
              <div className="container">
                  <h2>Chi può diventare Partner Ads Creator?</h2>
                  <div className="cards-container">
                      <div className="card1">
                          <p>✔️ Videomaker o freelance emergenti</p>
                      </div>
                      <div className="card1">
                          <p>✔️ Fotografi o appassionati di shooting creativi</p>
                      </div>
                      <div className="card1">
                          <p>✔️ Studenti di comunicazione</p>
                      </div>
                  </div>
              </div>
          </section>

          <section style={{paddingLeft: "2%", paddingRight: "2%"}} className='container mb-5 mt-5'>
              <link href="https://campaign.huberway.com/core/css/embedded.css" rel="stylesheet" type="text/css"/>
              <link href="https://fonts.googleapis.com/icon?family=Material+Icons+Outlined" rel="stylesheet"/>
              <div className="subscribe-embedded-form">
                  <h2 style={{color: "black"}} className="mt-0 text-center h_title wow fadeInUp">Candidati Ora</h2>
                  <form action="https://campaign.huberway.com/lists/67b5fda9f3dc8/embedded-form-subscribe-captcha"
                        method="POST" className="form-validate-jqueryz" noValidate="novalidate">
                      <div className="form-group control-text">
                          <label> Nome e Cognome <span className="text-danger">*</span></label><input id="NAME"
                                                                                                      placeholder=""
                                                                                                      type="text"
                                                                                                      name="NAME"
                                                                                                      className="form-control required"/>
                      </div>
                      <div className="form-group control-text">
                          <label> Email <span className="text-danger">*</span></label><input id="EMAIL" placeholder=""
                                                                                             type="text" name="EMAIL"
                                                                                             className="form-control required email:rfc,filter"/>
                      </div>
                      <div className="form-group control-textarea">
                          <label> Raccontaci la tua idea <span className="text-danger">*</span>
                          </label>
                          <textarea type="text" name="IDEA" className="form-control required ">
                          </textarea>
                      </div>
                      <div className="form-button text-center">
                          <button className="action_btn">Invia</button>
                      </div>
                  </form>
              </div>
          </section>

          <footer>
              <div className="container">
                  <p>&copy; 2025 Psicopatici Italia. Tutti i diritti riservati.</p>
              </div>
          </footer>
      </div>
  );
};

export default AdsCreator;
